require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.define-property");

(function (d, a) {
  "object" === typeof exports && "object" === typeof module ? module.exports = a() : "function" === typeof define && define.amd ? define("extractDomain", [], a) : "object" === typeof exports ? exports.extractDomain = a() : d.extractDomain = a();
})("undefined" !== typeof self ? self : this, function () {
  return function (d) {
    function a(c) {
      if (e[c]) return e[c].exports;
      var b = e[c] = {
        i: c,
        l: !1,
        exports: {}
      };
      d[c].call(b.exports, b, b.exports, a);
      b.l = !0;
      return b.exports;
    }

    var e = {};
    a.m = d;
    a.c = e;

    a.d = function (c, b, d) {
      a.o(c, b) || Object.defineProperty(c, b, {
        configurable: !1,
        enumerable: !0,
        get: d
      });
    };

    a.n = function (c) {
      var b = c && c.__esModule ? function () {
        return c["default"];
      } : function () {
        return c;
      };
      a.d(b, "a", b);
      return b;
    };

    a.o = function (c, a) {
      return Object.prototype.hasOwnProperty.call(c, a);
    };

    a.p = "";
    return a(a.s = 0);
  }([function (d, a, e) {
    function c() {
      throw new TypeError("The given URL is not a string. Please verify your string|array.");
    }

    function b(a) {
      "string" !== typeof a && c();

      for (var b = 0, d = 0, g = 0, e = a.length, f = 0; e-- && ++f && !(b && -1 < h.indexOf(a[f]));) {
        "." === a[f] && (++b, d = f);
      }

      b = f;

      for (f = d; f--;) {
        if (-1 !== k.indexOf(a[f])) {
          g = f + 1;
          break;
        }
      }

      return 2 > g ? "" : a.slice(g, b);
    }

    var h = ["/", ":", "?", "#"],
        k = [".", "/", "@"];

    d.exports = function (a) {
      if ("string" === typeof a) return b(a);

      if (Array.isArray(a)) {
        var d = [],
            e,
            g = 0;

        for (e = a.length; g < e; g++) {
          d.push(b(a[g]));
        }

        return d;
      }

      c();
    };
  }]);
});